import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const UnlinkIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Unlink",
    children: /*#__PURE__*/_jsx("path", {
      d: "M20.29 17.65c-.78 0-1.42.63-1.42 1.42v5.31c0 .07-.05.12-.12.12h-5.47c-.07 0-.12-.05-.12-.12v-5.31c0-.78-.63-1.42-1.42-1.42s-1.42.63-1.42 1.42v5.31c0 1.63 1.32 2.95 2.95 2.95h5.43c1.63 0 2.95-1.32 2.95-2.95v-5.31c0-.77-.61-1.4-1.38-1.42Zm1.37-10.03c0-1.63-1.32-2.95-2.95-2.95h-5.42c-1.63 0-2.95 1.32-2.95 2.95v5.31c0 .78.63 1.42 1.42 1.42s1.42-.63 1.42-1.42V7.62c0-.07.05-.12.12-.12h5.43c.07 0 .12.05.12.12v5.31c0 .78.63 1.42 1.42 1.42s1.42-.63 1.42-1.42V7.62Zm6.92 6.96h-2.83c-.78 0-1.42.63-1.42 1.42s.63 1.42 1.42 1.42h2.83c.78 0 1.42-.63 1.42-1.42s-.63-1.42-1.42-1.42M3.41 17.41h2.83c.78 0 1.42-.63 1.42-1.42s-.63-1.42-1.42-1.42H3.41c-.78 0-1.42.63-1.42 1.42s.63 1.42 1.42 1.42m3.08-4.66c.26.26.61.42 1 .42.78 0 1.42-.64 1.42-1.42 0-.39-.16-.75-.42-1L7.07 9.33c-.26-.26-.61-.42-1-.42-.78 0-1.42.64-1.42 1.42 0 .39.16.75.42 1zM24.9 9.33l-1.42 1.42c-.29.26-.47.64-.47 1.05 0 .78.63 1.42 1.42 1.42.42 0 .79-.18 1.05-.47s1.42-1.42 1.42-1.42c.29-.26.47-.64.47-1.05 0-.78-.63-1.42-1.42-1.42-.42 0-.79.18-1.05.47m.59 9.91c-.25-.22-.58-.36-.95-.36-.78 0-1.42.63-1.42 1.42 0 .36.14.7.36.95s1.42 1.41 1.42 1.41c.25.22.58.36.95.36.78 0 1.42-.63 1.42-1.42 0-.36-.14-.7-.36-.95s-1.42-1.41-1.42-1.41M6.07 23.08c.39 0 .74-.16.99-.41l1.42-1.42c.22-.25.36-.58.36-.95 0-.78-.63-1.42-1.42-1.42-.36 0-.7.14-.95.36s-1.42 1.41-1.42 1.41c-.26.26-.42.61-.42 1 0 .78.63 1.42 1.42 1.42Z"
    })
  }));
};